module.exports = __webpack_public_path__ + "static/media/die.5159f211.png";